<template>
    <kgr-club-dunning-settings-data-provider
        v-slot="clubDunningSettingsScope"
        :club-id="clubId"
        :callback="onClubDunningSettingsLoaded"
    >
        <div class="animated fadeIn">
            <kgr-form-scaffold
                :pending="pending"
                :with-back-button="false"
                :save-button-disabled="saveButtonDisabled"
                :with-primary-buttons="isEditable"
                @primaryBtnClicked="update(clubDunningSettingsScope.reload)"
            >
                <div class="kgr-row">
                    <kgr-club-dunning-text-settings-form
                        :error="error"
                        :club-dunning-settings.sync="clubDunningSettings"
                        class="animated fadeIn"
                        @enter="update(clubDunningSettingsScope.reload)"
                    />
                </div>
            </kgr-form-scaffold>
        </div>
    </kgr-club-dunning-settings-data-provider>
</template>

<script>
import ClubDunningSettingsDataProvider from '../../../components/data-provider/ClubDunningSettingsDataProvider';
import ClubDunningSettingsRepository from '../../../js/repository/ClubDunningSettingsRepository';
import ClubDunningTextSettingsForm from '../../../components/club/dunning-settings/ClubDunningTextSettingsForm';
import Error from '../../../js/model/Error';
import FormScaffold from '../../../components/common/form/FormScaffold';

export default {
    components: {
        'kgr-club-dunning-settings-data-provider': ClubDunningSettingsDataProvider,
        'kgr-club-dunning-text-settings-form': ClubDunningTextSettingsForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            clubDunningSettings: null,
            pending: false,
        };
    },
    computed: {
        saveButtonDisabled() {
            return this.clubDunningSettings === null;
        },
    },
    methods: {
        onClubDunningSettingsLoaded(loadedClubDunningSettings) {
            this.clubDunningSettings = loadedClubDunningSettings;
        },
        update(reload) {
            this.pending = true;
            ClubDunningSettingsRepository.update(this.clubId, this.clubDunningSettings)
                .then(() => {
                    this.error = new Error();
                    reload();
                    this.$notify.success('saveChanges.success');
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                })
                .finally(() => this.pending = false);
        },
    },
};
</script>
